<template>
  <QuestionBase :errors="[...serverErrors, ...jsErrors]"
                :question="question"
                :valid="data !== null">
    <InputRadio ref="input"
                v-model="data"
                :args="args"
                :db="db"
                :disabled="!!liabilities.length"
                :no-save="false"
                :options="booleanYesNo"
                :server-errors="serverErrors"
                @jsErrors="jsErrors=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";
import {general} from "../../../options/general";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'LiabilitiesCreditCardsYN',
  mixins: [
    general,
    questionLoadHelpers
  ],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    liabilities: {
      type: Array,
      required: true
    }
  },
  mounted() {
    // set initial question value (yes/no) based on assets
    if (this.liabilities.length && !this.data) {
      this.$refs.input.data = true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'Do you have any balances outstanding on credit cards?',
        subTitle: 'Small balances (£100 or under) on credit or store cards need not be added.',
        tip: null,
      },
      db: {
        saveLocation: 'client_client',
        saveField: 'credit_card_balances'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>